export default __webpack_public_path__ + "static/partners-183fd19898fa140d84b2e4a3493e6a68.png";